import React from 'react';
import PropTypes from 'prop-types';

import { PreviewCondition } from '@sopranodesign/pulse-components';
import { ConditionPreview } from '@sopranodesign/pulse-conditionals';

const IntegrationPreview = ({ prefix = 'When', ...props }) => (
  <p>
    {prefix} making request to endpoint
    {props.subject.target ? ` and ${props.subject.target}` : ' and response'}
    <PreviewCondition>{props.type.name}</PreviewCondition>
    <ConditionPreview {...props} />
  </p>
);

IntegrationPreview.propTypes = {
  prefix: PropTypes.string,
  subject: PropTypes.shape({
    target: PropTypes.string
  }),
  flipped: PropTypes.number,
  type: PropTypes.shape({ type: PropTypes.string, name: PropTypes.string })
};

export default IntegrationPreview;
